import { request } from "@/utils/request";
// 查询
export function selectApi(data) {
  return request({
    url: `/sendService/sendRecord/select`,
    method: "POST",
    data,
  });
}

// 新增
export function addApi(data) {
  return request({
    url: `/sendService/sendRecord/add`,
    method: "POST",
    data,
  });
}

/* 修改 */
export function updateApi(data) {
  return request({
    url: `/sendService/sendRecord/update`,
    method: "POST",
    data,
  });
}

// 删除
export function deleteApi(data) {
  return request({
    url: `/sendService/sendRecord/delete`,
    method: "POST",
    data,
  });
}
